import { type CoastLoadedMessage, MESSAGE_TYPES } from './messages';

/**
 * Sends COAST_LOADED message to the parent window.
 * This signals to the SDK that the embedded app has completed initialization.
 *
 * Uses '*' for targetOrigin because we cannot access the parent's origin
 * from a cross-origin iframe. This is safe because COAST_LOADED contains
 * no sensitive data — security is enforced by validating incoming message origins.
 */
export function sendCoastLoaded(): void {
  const message: CoastLoadedMessage = { type: MESSAGE_TYPES.LOADED };
  window.parent.postMessage(message, '*');
}
